import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './editorial-counters.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialCounters = (context) => {
  const editorialCountersSection = context.closest('.shopify-section');
  if (!editorialCountersSection) return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.editorial-counters__icon__number').forEach(number => {
    var count = number,
      zero = {
        val: 0
      },
      num = count.dataset.number,
      suffix = count.dataset.suffix,
      split = (num + "").split("."),
      decimals = split.length > 1 ? split[1].length : 0;

    gsap.to(zero, {
      val: num,
      duration: 2,
      scrollTrigger: number,
      onUpdate: function () {
        count.textContent = zero.val.toFixed(decimals) + suffix;
      }
    });

  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.editorial-counters__container'), (el) => {
    window.dAgency.initEditorialCounters(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.editorial-counters__container'), (el) => {
      window.dAgency.initEditorialCounters(el);
    });
  });
}
